module.exports = __webpack_public_path__ + "static/media/recycle-bin.dbe7eb79.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/recycle-bin.svg
// module id = 786
// module chunks = 0